import React from 'react';

export const FirmableLogo: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <div className="w-8 h-8 flex items-center justify-center">
    <svg
      {...props}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-full"
    >
      <path
        d="M34.5271 16.1382C35.2301 16.8411 35.2301 17.9808 34.5271 18.6838L29.4465 23.7644C28.7436 24.4674 27.6039 24.4674 26.9009 23.7644L18.0029 14.8664L22.2349 10.6344C24.1094 8.75991 27.1486 8.75988 29.0231 10.6343L34.5271 16.1382Z"
        fill="#A94004"
      />
      <path
        d="M21.3954 3.0074C19.5209 1.13296 16.4817 1.13295 14.6072 3.0074L1.47594 16.1385C0.772997 16.8414 0.772993 17.9811 1.47594 18.6841L6.55653 23.7647C7.25947 24.4676 8.39919 24.4676 9.10213 23.7647L18.0014 14.8655L18.0026 14.8667L22.2345 10.6348C24.109 8.76033 27.1482 8.76029 29.0228 10.6348L21.3954 3.0074Z"
        fill="#F15B06"
      />
      <path
        d="M16.7288 21.223C17.4317 20.5201 18.5714 20.5201 19.2744 21.223L24.3585 26.3072C25.0615 27.0101 25.0615 28.1498 24.3585 28.8528L19.2744 33.9369C18.5715 34.6399 17.4318 34.6399 16.7288 33.9369L11.6447 28.8528C10.9417 28.1498 10.9417 27.0101 11.6447 26.3072L16.7288 21.223Z"
        fill="#F15B06"
      />
    </svg>
  </div>
);
